import { render, staticRenderFns } from "./TaskPointTrend.vue?vue&type=template&id=130d8f88&scoped=true"
import script from "./TaskPointTrend.vue?vue&type=script&lang=js"
export * from "./TaskPointTrend.vue?vue&type=script&lang=js"
import style0 from "./TaskPointTrend.vue?vue&type=style&index=0&id=130d8f88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d8f88",
  null
  
)

export default component.exports